export default "__VITE_ASSET__LDXcuxQt__"